<template>
      <b-card dir="rtl" no-body>
        <div class="loading_page" v-if="isBusy">
          <orbit-spinner :animation-duration="1000" :size="30" :color="'#0e96b1'"/>
        </div>
        <b-card-header class="pb-50">
          <h5> {{ $t('Filters') }} </h5>
        </b-card-header>
        <b-card-body>
          <b-row v-for="filter in filters">
              <b-col v-if="filter.type == 'list'" lg="12" md="12" class="mb-md-0 mb-2">
                <label>{{ $t(filter.title) }}</label>
                <v-select 
                  multiple 
                  :close-on-select="false"
                  :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'"
                  :options="filter.options"
                  v-model="filterValue[filter.key].selected"
                />
              </b-col>
          </b-row>
        </b-card-body>
      </b-card>
</template>

<script>

import { ref, toRefs, computed, watch } from '@vue/composition-api'
import { OrbitSpinner } from 'epic-spinners'
import {
  BRow,
  BCol,
  BCard,
  BDropdown,
  BDropdownItem,  
  VBTooltip, 
  VBToggle, 
  BCardHeader, 
  BCardBody,
  BFormCheckbox
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'


export default {
  directives: {
    'b-tooltip': VBTooltip,
    'b-toggle': VBToggle,
    Ripple,
  },
  components: {
    OrbitSpinner,
    BCardBody,
    BCardHeader,
    BFormCheckbox,
    vSelect,
    BDropdownItem,
    BDropdown,
    BCard,
    BRow,
    BCol
  },
  props:{
    fields: {
      type:Array,
      required: true
    },
    data: {
      type:Array,
      required: true
    },
    isBusy: {
      type:Boolean,
      required: true
    }
  },
  emits:['filtered'],
  setup(props, { root, emit }) {

    const { fields, data } = toRefs(props)

    const filters = computed(()=> {
      return fields.value.map((field)=> {
        if(field.type == 'list'){
          return {...field, options:[...new Set(data.value.map((item)=> item[field.key]))].filter((option)=> option != null)}
        }
        return field
      })
    })

    const filterValue = ref(fields.value.reduce((prev, cur) => {
      prev[cur.key] = {...cur, selected:[]}
      return prev
    }, {}))
    

    const filterData = () => {
      emit('filtered', data.value.filter((item)=> {

          let belong = true

          Object.entries(filterValue.value).forEach( entry => {

              const [key, value] = entry

              if(value.type == 'list'){
                  if(!(value.selected.includes(item[key]) || value.selected.length == 0)){
                    belong = false
                  }
              }

          })

          return belong;

      }))
    }

    watch([data, filterValue], filterData, {deep:true})

    return {
      filters,
      filterValue
    }
  }
}


</script>
